module.exports = __webpack_public_path__ + "img/img_page_04_01.e412c14e.png";